import React from "react";
import GoBackButton from "../../components/GoBackButton";
import Header from "../../components/Header";

export default props => {
    return (
        <div>
            <Header/>
            <section className="text-based ">
                <div className="row">
                <div className="pdr">
                    <GoBackButton/>
                    <h3>Open Positions: </h3> <br /><br />
                    <div>
                    <h5>
                        <b>Role</b>: FIELD MANAGER I <br /><br />
                        Hours: Full Time <br />
                        Salary: $47,000/year <br />
                        Benefits: Company Vehicle | Corporate Fuel Card | Allowance for Schedule Flexibility <br />
                        Hiring: Immediately <br /><br />
                        Duties: 
                        The Field Manager I position reports directly to EVP, Wholesale &amp; Operations, N.A. and is an integral part of our organization. 
                        The Field Manager I will spend most of the day in the field overseeing installations and aiding installers with material deliveries. The Field Manager I will also assist the Executive Team with customer insights and operational planning. <br /><br />
                        ​
                        The right candidate will possess: <br />
                        A valid driver’s license with clean driving record <br />
                        A clean criminal record <br />
                        An energetic presence <br />
                        The ability to think on their feet and make quick, necessary decisions to move the work forward and complete within the allotted time frame <br />
                        A communicative and honest personality <br />
                        The willingness to learn and be coached to success <br />
                        The ability to lift a minimum of 75 pounds <br />
                        Exceptional physical health <br /><br />
                        ​
                        Join our team and build valuable career skills in a cohesively managed and highly collaborative company <br /> <br />
                        ​
                        Submit your resume to:  <br />
                        careers@solydfloors.com <br />
                        SUBJ: Field Manager I | Your Full Name
                    </h5>
                    ​
                    <hr />
                    ​
                    <h5>
                        <b>Role:</b> FLOOR COVERING SALES EXECUTIVE II <br /> <br />
                        Hours: Full Time <br />
                        Salary: Base (TBD based on qualifications) + Commission + Bonus <br />
                        Benefits: Corporate Fuel Card | Allowance for Schedule Flexibility <br />
                        Hiring: Immediately<br />
                        Duties:
                        The Floor Covering Sales Executive II will be responsible for selling Solyd Floors LVP to prospective retail showrooms and wholesalers throughout the Mid-Atlantic Region. The Floor Covering Sales Executive II will develop relationships with dealers and distributors in order to sell our flooring products and expand our market share. <br /><br />
                        ​
                        The right candidate will possess: <br />
                        A valid driver’s license with clean driving record<br />
                        A clean criminal record<br />
                        An energetic presence <br />
                        The ability to successfully place our flooring products in showrooms and support dealers and distributors<br />
                        A communicative and honest personality <br />
                        The willingness to learn and be coached to success, or teach and coach to success (depending on your experience) <br />
                        The ability to lift a minimum of 75 pounds <br />
                        Exceptional physical health <br />
                        A working vehicle <br />
                        A willingness to travel and spend most of your time in the field in front of prospects <br /><br />
                        ​
                        Submit your resume to: <br />
                        careers@solydfloors.com <br />
                        SUBJ: Floor Covering Sales Executive II | Your Full Name
                    </h5>
                    ​
                    <hr />
                    ​
                    <h5>
                        <b>Role</b>: ACCOUNT MANAGER I <br /><br />
                        Hours: Flex | Part-Time <br />
                        Salary: Base (TBD based on qualifications) + Bonus <br />
                        Benefits: Remote Work | Cell phone allowance | Flexibility <br />
                        Hiring: Immediately <br />
                        Duties:
                        The Account Manager I will serve as the point of contact for Solyd Floors Commercial Division and will be responsible for communicating PROMPTLY (inbound AND outbound communication) to our Commercial clients. The Account Manager I will build relationships at varying seniority and responsibility levels of their managed accounts.
                        ​
                        The right candidate will possess: <br />
                        A well-developed sense of urgency <br />
                        A clean criminal record <br />
                        An energetic presence <br />
                        The ability to communicate quickly, effectively AND cordially with account contacts <br />
                        A communicative and honest personality <br />
                        The willingness to learn and be coached to success, or teach and coach to success (depending on your experience) <br />
                        The ability to communicate account needs to management effectively <br />
                        Access to the internet at their remote work location <br /><br />
                        ​
                        Submit your resume to: <br />
                        careers@solydfloors.com<br />
                        SUBJ: Account Manager I | Your Full Name
                        ​
                    </h5>
                    </div>
                </div>
                </div>
            </section>

        </div>
    )
}